/**
 * キャスト週まとめ登録の差分算出（純粋関数）。
 * ダイアログの7日分の入力状態から、実行すべき 作成/更新/却下 を導出する。
 * 指名予約ロック日はいかなる操作も生成しない（サーバ側でも検証されるが二重に守る）
 *
 * row: {
 *   date: 'yyyy-MM-dd',
 *   checked: boolean,
 *   locked: boolean,
 *   startTime: 'HH:mm' | '',
 *   endTime: 'HH:mm' | '',
 *   // requestType: キャストアプリの回答種別（'work'|'absent'|'undecided'。旧データはundefined=work）
 *   existing: { id, startTime: 'HH:mm'|'', endTime: 'HH:mm'|'', requestType?: string } | null,
 * }
 */
const isWorkExisting = existing => !existing.requestType || existing.requestType === 'work'

export const buildCastWeekOps = rows => {
  const normalize = value => value || ''

  // 出勤のみ（退勤未定）は許容する。退勤だけの指定は不可
  const invalid = (rows || []).find(row => {
    if (row.locked || !row.checked) return false

    return normalize(row.startTime) === '' && normalize(row.endTime) !== ''
  })
  if (invalid) {
    return { ok: false, error: `${invalid.date} は退勤だけは設定できません。出勤時間も入力してください` }
  }

  const creates = []
  const updates = []
  const rejects = [];
  (rows || []).forEach(row => {
    if (row.locked) return

    const start = normalize(row.startTime)
    const end = normalize(row.endTime)

    if (row.checked && !row.existing) {
      creates.push({ date: row.date, startTime: start, endTime: end })

      return
    }

    if (row.checked && row.existing) {
      // 休み・未定の回答日にチェックを入れた場合は「出勤」への上書き登録
      if (!isWorkExisting(row.existing)) {
        updates.push({
          id: row.existing.id, date: row.date, startTime: start, endTime: end, requestType: 'work',
        })

        return
      }
      const changed = start !== normalize(row.existing.startTime) || end !== normalize(row.existing.endTime)
      if (changed) {
        updates.push({
          id: row.existing.id, date: row.date, startTime: start, endTime: end,
        })
      }

      return
    }

    if (!row.checked && row.existing) {
      // 休み・未定の回答はキャストの意思表示なので、チェック無しでは何もしない（却下しない）
      if (!isWorkExisting(row.existing)) return
      rejects.push(row.existing.id)
    }
  })

  return {
    ok: true, creates, updates, rejects,
  }
}
